import { Controller } from "@hotwired/stimulus"

// A popup: the round's replies. Opens as a modal, closes with its button, Esc,
// or a click on the backdrop.
//
// The page refreshes by morphing when a reply lands. The server renders the
// dialog closed, so a morph would take away its `open` and shut it on the
// tester. Refuse that one change: the content still updates, so a reply that
// lands while the popup is open appears in it.
export default class extends Controller {
  static targets = ["dialog"]

  connect() {
    this.hold = this.hold.bind(this)
    this.element.addEventListener("turbo:before-morph-attribute", this.hold)
  }

  disconnect() {
    this.element.removeEventListener("turbo:before-morph-attribute", this.hold)
  }

  open() {
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  // A click on the backdrop lands on the dialog itself, not on its content.
  backdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  hold(event) {
    if (event.target === this.dialogTarget && event.detail.attributeName === "open") event.preventDefault()
  }
}
